<template>
	<view class="content">
		<view class="img" v-for="(item,index) in imgs" :key="index">
			<img :src="item"/>
		</view>
	</view>
</template>

<script>
	export default {
		name:"image_list",
		data() {
			return {
				imgs:[]
			};
		},
		props:{
			path:String,
			count:Number
		},
		watch:{
			path(newValue,oldValue){
				this.Test();
			}
		},
		methods:{
			Test(){
				this.imgs = [];
				let path = 'dp/'+this.path;
				for(let i =1;i<=this.count;i++){
					let index = i.toString().padStart(2,'0');
					let name = 'img_'+index+'.jpg';
					this.imgs.push(path+name);
				}
			}
		},
		created() {
			this.Test();
		}
	}
</script>

<style lang="scss" scoped>
	
.content{
	width: 100%;
	.img{
		
		padding: 0 10px;
	
		img{
			width: 100%;
		}
	}
}

</style>